import { romeApi, utils } from "framework";

const state = {
    ready: false,
    employerId: null,
    cobraConfig: null,
};

const getters = { };

const actions = {
    async load(context, data) {
        if(!data.force && (!data.employerId || context.state.employerId == data.employerId)) return;
        // console.log("x-cobra-config load data: ", data.employerId, state.employerId);

        context.state.ready = false;
        let config = await romeApi.get(`employer/${data.employerId}/cobra`);
        context.commit('setCobraConfig', config);
        context.commit('setEmployerId', data.employerId);
        context.state.ready = true;
    },
};

const mutations = {
    setEmployerId(state, employerId) {
        // console.log("x-cobra-config mutation setEmployer data: ", employerId);
        state.employerId = employerId;
    },
    setCobraConfig(state, data) {
        // console.log("x-cobra-config mutation setCobraPlan data: ", data);
        state.cobraConfig = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};


// WEBPACK FOOTER //
// ./src/cobra/x-cobra-config.js